import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFeaturePermissions } from '../selectors/permissions';

const mapStateToProps = (state, ownProps) => {
    const { typesMap, permission, isSingleAccessLevel } = getFeaturePermissions(state);
    const types = Object.keys(typesMap);
    const requiredPermissionName = Object.keys(ownProps).find(prop => types.includes(prop));
    const { requiredSingleAccessLevel } = ownProps;
    if (!requiredPermissionName) {
        console.warn(`Couldn't find a valid permission type in: ${Object.keys(ownProps)}`);
        return {
            typesMap,
            requiredPermission: typesMap.read,
            permission: typesMap.read,
            requiredSingleAccessLevel,
            isSingleAccessLevel,
        };
    }

    const requiredPermission = typesMap[requiredPermissionName];
    return {
        typesMap,
        requiredPermission,
        permission,
        requiredSingleAccessLevel,
        isSingleAccessLevel,
    };
};

const PermissionsWrapper = ({
    typesMap,
    children = null,
    requiredSingleAccessLevel = false,
    isSingleAccessLevel = false,
    ...props
}) => {
    const { permission = typesMap.readWrite, requiredPermission = typesMap.read } = props;
    if (permission < requiredPermission || (requiredSingleAccessLevel && !isSingleAccessLevel)) {
        return null;
    }
    return children;
};

PermissionsWrapper.propTypes = {
    typesMap: PropTypes.objectOf(PropTypes.number).isRequired,
    children: PropTypes.any,
    permission: PropTypes.number,
    requiredPermission: PropTypes.number,
    requiredSingleAccessLevel: PropTypes.bool,
    isSingleAccessLevel: PropTypes.bool,
};

const PermissionsWrapperContainer = connect(mapStateToProps, null)(PermissionsWrapper);

export default PermissionsWrapperContainer;
